export const isEmptyOrUndefined = (s: string | undefined) => s === undefined || s === '';

export function getEnumValues<T extends object>(enumObject: T): { name: string; value: string }[] {
  return Object.keys(enumObject)
    .filter((key) => Number.isNaN(Number(key)))
    .map((key) => ({ name: key, value: enumObject[key as keyof T] as string }));
}
